import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Logo = function(_param) {
    var isDark = _param.isDark, props = _object_without_properties(_param, [
        "isDark"
    ]);
    // const textColor = isDark ? "#FFFFFF" : "#000000";
    // const gradientColor = isDark ? "#bababa" : "#767676";
    var textColor = "#FFFFFF";
    var gradientColor = "#bababa";
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 841.2 100.09"
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "a",
                        cx: 40.5,
                        cy: 49.34,
                        r: 45.13,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 0,
                                stopColor: textColor
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 0.64,
                                stopColor: textColor
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 1,
                                stopColor: gradientColor
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("radialGradient", {
                        id: "b",
                        cx: 320.82,
                        cy: 49.3,
                        r: 43.12,
                        xlinkHref: "#a"
                    }),
                    /*#__PURE__*/ _jsx("radialGradient", {
                        id: "c",
                        cx: 233.16,
                        cy: 49.37,
                        r: 48.2,
                        xlinkHref: "#a"
                    }),
                    /*#__PURE__*/ _jsx("radialGradient", {
                        id: "d",
                        cx: 150.31,
                        cy: 49.33,
                        r: 43.91,
                        xlinkHref: "#a"
                    }),
                    /*#__PURE__*/ _jsx("radialGradient", {
                        id: "e",
                        cx: 806.02,
                        cy: 60.37,
                        r: 37.52,
                        xlinkHref: "#a"
                    }),
                    /*#__PURE__*/ _jsx("radialGradient", {
                        id: "f",
                        cx: 428.99,
                        cy: 49.33,
                        r: 43.13,
                        xlinkHref: "#a"
                    }),
                    /*#__PURE__*/ _jsx("radialGradient", {
                        id: "g",
                        cx: 597.06,
                        cy: 60.35,
                        r: 36.2,
                        xlinkHref: "#a"
                    }),
                    /*#__PURE__*/ _jsx("radialGradient", {
                        id: "h",
                        cx: 530.07,
                        cy: 59.67,
                        r: 36.26,
                        xlinkHref: "#a"
                    }),
                    /*#__PURE__*/ _jsx("radialGradient", {
                        id: "i",
                        cx: 665.53,
                        cy: 59.67,
                        r: 36.26,
                        xlinkHref: "#a"
                    }),
                    /*#__PURE__*/ _jsx("radialGradient", {
                        id: "j",
                        cx: 734.73,
                        cy: 60.36,
                        r: 37.21,
                        xlinkHref: "#a"
                    }),
                    /*#__PURE__*/ _jsx("radialGradient", {
                        id: "k",
                        cx: 95.63,
                        cy: 49.3,
                        r: 35.6,
                        xlinkHref: "#a"
                    }),
                    /*#__PURE__*/ _jsx("radialGradient", {
                        id: "l",
                        cx: 480,
                        cy: 60.51,
                        r: 27.91,
                        xlinkHref: "#a"
                    }),
                    /*#__PURE__*/ _jsx("radialGradient", {
                        id: "m",
                        cx: 479.98,
                        cy: 7.91,
                        r: 9.04,
                        xlinkHref: "#a"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("g", {
                "data-name": "Layer 2",
                children: /*#__PURE__*/ _jsxs("g", {
                    "data-name": "Layer 1",
                    children: [
                        /*#__PURE__*/ _jsx("path", {
                            d: "m65.09 51.27 1.24.59c1.09.56 2.2 1.07 3.24 1.71a13.25 13.25 0 0 1 5.53 6.9A29.65 29.65 0 0 1 76.75 68c.28 2.9.42 5.8.61 8.71.09 1.31.18 2.62.22 3.94.07 2.48.08 5 .18 7.46a37 37 0 0 0 .36 4.2A9.52 9.52 0 0 0 81 98.37a2 2 0 0 1-.08.2.18.18 0 0 1-.12.05H59.17c-.18-.31-.37-.62-.52-1a14.93 14.93 0 0 1-1.22-4.47 79 79 0 0 1-.69-8.27c0-3.15-.12-6.29-.26-9.44a29.6 29.6 0 0 0-1.39-8 28.22 28.22 0 0 0-1.2-2.85 5.7 5.7 0 0 0-2.53-2.56 11.73 11.73 0 0 0-4-1.38 34.76 34.76 0 0 0-4.76-.49c-7.09-.06-14.19 0-21.29 0-.27 0-.54.05-.87.08a46 46 0 0 0-.1 4.82v33.29c-.48.44-1 .29-1.43.29H1.32c-.37 0-.74 0-1.19-.05 0-.32-.1-.59-.12-.85S0 97 0 96.62V11a14.59 14.59 0 0 1 .19-2.82A10.25 10.25 0 0 1 9.73 0h38.63a49.86 49.86 0 0 1 12.7 1.49 33.18 33.18 0 0 1 3.62 1.17 22.12 22.12 0 0 1 13.78 15.15 35.36 35.36 0 0 1 1.29 10.73A31.59 31.59 0 0 1 78.53 37a23.84 23.84 0 0 1-3.9 7.6 18.94 18.94 0 0 1-7.77 5.9c-.51.24-1.03.5-1.77.77Zm-44.67-8.36c.6 0 1.07.05 1.53.05h21.42c1.08 0 2.16 0 3.24-.07a19.42 19.42 0 0 0 6.16-1.34 9.84 9.84 0 0 0 6-6.81 18.13 18.13 0 0 0 .27-8.09 11 11 0 0 0-7.48-8.76A15.63 15.63 0 0 0 45.9 17H21.66c-.41 0-.85-.12-1.24.24Z",
                            style: {
                                fill: "url(#a)"
                            }
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M305.17 17c-.23 1.59-.3 12-.16 20 0 .32.05.64.08 1a7.6 7.6 0 0 0 .86.1h37.4a5.48 5.48 0 0 1 .15.87c0 2 .05 3.94 0 5.92a10.28 10.28 0 0 1-7.16 9.63 11 11 0 0 1-3.47.46H305.3a2.13 2.13 0 0 0-.28 1.58V80a6 6 0 0 0 .85.2H356.37c.46.43.34.88.34 1.28v15.64a1.93 1.93 0 0 1-.25 1.4H285.1a6.29 6.29 0 0 1-.16-.8V11a16.55 16.55 0 0 1 .06-2.08A10.32 10.32 0 0 1 295.21 0c6 .06 12 0 18.05 0h43.27a3 3 0 0 1 .16.62V16.4a1.47 1.47 0 0 1-.17.42c-1.39.15-2.8.05-4.2.07s-2.91 0-4.37 0h-42.78Z",
                            style: {
                                fill: "url(#b)"
                            }
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M244.52 0q17.86 49.15 35.64 98.11a1.07 1.07 0 0 1 0 .4c-1.08.15-19.22.19-21.18 0a2.72 2.72 0 0 1-.6-1.36q-2.83-8.68-5.65-17.39c-.16-.49-.33-1-.48-1.4-1.17-.18-36.73-.22-38.32-.05-.45.38-.46 1-.63 1.5q-2.7 8.67-5.38 17.34c-.14.44-.3.87-.46 1.35-.37 0-.69.07-1 .08-8.49.13-19 .07-20.29-.12a2.73 2.73 0 0 1 .39-1.6q3.36-9.56 6.77-19.1 12.51-35.13 25-70.26a19.09 19.09 0 0 1 1-2.46 9.19 9.19 0 0 1 7.66-5 10.63 10.63 0 0 1 1.3-.04h16.23Zm-25.08 61.5a4.63 4.63 0 0 0 1.62.14H245a7.82 7.82 0 0 0 .84 0 6.62 6.62 0 0 0 .82-.21c-.17-.57-.3-1.07-.46-1.56Q241.13 44.46 236.05 29c-.86-2.62-1.72-5.25-2.61-7.87-.09-.27 0-.7-.51-.72-.56 1.23-13.26 39.87-13.49 41.11Z",
                            style: {
                                fill: "url(#c)"
                            }
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M133 63.38c-.08 1.36 0 2.53 0 3.7v31.47a4.38 4.38 0 0 1-.75.13h-18.84a6.26 6.26 0 0 1-.7-.08 4.75 4.75 0 0 1-.12-.59V10.94a12.56 12.56 0 0 1 .22-2.94 10.25 10.25 0 0 1 9.69-8h34.39a43 43 0 0 1 11.57 1.46 28 28 0 0 1 2.94 1c7.5 2.95 12.3 8.4 14.77 16a38.13 38.13 0 0 1 1.74 9.53 56 56 0 0 1 0 7.88 37 37 0 0 1-2.79 12 23.89 23.89 0 0 1-16.57 14.25 40.12 40.12 0 0 1-10.46 1.27h-23.26Zm.08-17.94a3.18 3.18 0 0 0 1.5.16h16.63c1.45 0 2.91-.06 4.36-.14a16.82 16.82 0 0 0 4.55-.88 10.56 10.56 0 0 0 7.22-7.79 23.61 23.61 0 0 0 .46-8.25 16.14 16.14 0 0 0-1.22-4.6 9.48 9.48 0 0 0-5.33-5.32 17.36 17.36 0 0 0-5.59-1.32c-.88-.06-1.78-.06-2.67-.06h-18.46a2.93 2.93 0 0 0-1.47.15c-.18 1.44-.17 26.93 0 28.05Z",
                            style: {
                                fill: "url(#d)"
                            }
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M841 65.64c-2.23.09-4.29 0-6.35 0h-43.2a3.08 3.08 0 0 0-.13.71 24.14 24.14 0 0 0 1.46 7.85 15 15 0 0 0 3.91 5.8 11.48 11.48 0 0 0 5.15 2.78 19.49 19.49 0 0 0 10.16-.09 17.44 17.44 0 0 0 3.73-1.63 7.49 7.49 0 0 0 2.44-2.31 8.23 8.23 0 0 1 7.21-3.66h14.41a2.17 2.17 0 0 1 .05.63 31.32 31.32 0 0 1-22.63 22.88 44.17 44.17 0 0 1-21.07.41c-8.91-2-15.47-7.19-20-15a37.82 37.82 0 0 1-4.24-12 65.21 65.21 0 0 1-.9-16.33 50.54 50.54 0 0 1 2.33-12.84 32.78 32.78 0 0 1 8.19-13.46 29.69 29.69 0 0 1 15.16-7.89 45.5 45.5 0 0 1 13.18-.64 39.45 39.45 0 0 1 10.56 2.32 29.37 29.37 0 0 1 10.89 7.08 31.14 31.14 0 0 1 6 9.28 43.86 43.86 0 0 1 3.12 11.07 79.81 79.81 0 0 1 .73 12.92c.02.65-.09 1.3-.16 2.12Zm-49.6-13a9.5 9.5 0 0 0 1 .09h27a8.31 8.31 0 0 0 1-.11 3.67 3.67 0 0 0 0-.62 54.3 54.3 0 0 0-.28-2.23 19.44 19.44 0 0 0-1.72-5.63 11.52 11.52 0 0 0-7-6.08 17.47 17.47 0 0 0-8.34-.57 13 13 0 0 0-10.13 7.62 17.15 17.15 0 0 0-1.59 6.8 5.1 5.1 0 0 0 .04.77Z",
                            style: {
                                fill: "url(#e)"
                            }
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M464.69 0c.18 1.39.26 12.56.13 16.1a5.76 5.76 0 0 1-.09.73 48.27 48.27 0 0 1-5.09.09h-46.22a2.15 2.15 0 0 0-.25 1.56V37.07c0 .27 0 .55.07.9.29 0 .56.1.82.12h37.42a8.61 8.61 0 0 1 .11.87v5.92A10.27 10.27 0 0 1 441.41 55H413.31c-.05.35-.1.61-.12.88v42.63a4.13 4.13 0 0 1-.74.13h-18.47a6.26 6.26 0 0 1-.7-.08 4.17 4.17 0 0 1-.13-.58V10.94a12.78 12.78 0 0 1 .35-3.49A10.29 10.29 0 0 1 402.75 0h61.94Z",
                            style: {
                                fill: "url(#f)"
                            }
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M585.9 41.83h-18.24a5.78 5.78 0 0 1-.7-.08 2.93 2.93 0 0 1 .07-1.42c1.36-6.88 5.26-11.92 11.2-15.47a28.4 28.4 0 0 1 9.22-3.36 57.14 57.14 0 0 1 14.6-.7 60.68 60.68 0 0 1 7.83 1 34.77 34.77 0 0 1 8 2.55 20.58 20.58 0 0 1 7.6 5.92 17.54 17.54 0 0 1 3.72 9.57c.1 1.07.13 2.15.13 3.23v24.51a55.63 55.63 0 0 1-.4 7.3 29 29 0 0 1-1.74 7.24 25.42 25.42 0 0 1-11.93 13.37 34.75 34.75 0 0 1-12.87 3.87 106.51 106.51 0 0 1-12.37.72 30.77 30.77 0 0 1-15.81-4.43A18 18 0 0 1 565.73 84a32.82 32.82 0 0 1 0-16 16.42 16.42 0 0 1 7.33-10.12 40.7 40.7 0 0 1 12.29-5.12 62.85 62.85 0 0 1 6.52-1.08c3-.43 5.94-.93 8.9-1.44a22.37 22.37 0 0 0 4.86-1.42 12.38 12.38 0 0 0 2.79-1.62 5.32 5.32 0 0 0-1.05-8.91 19.87 19.87 0 0 0-4.18-1.24 23.5 23.5 0 0 0-9-.34 28.93 28.93 0 0 0-3.28.78 7.55 7.55 0 0 0-4.53 3.57c-.12.2-.25.39-.38.59a1 1 0 0 1-.1.18Zm24.68 18.56c-.32.1-.58.16-.83.26-1 .38-2 .81-3 1.17a78.28 78.28 0 0 1-10.46 2.8A34.65 34.65 0 0 0 590 66.3a15.88 15.88 0 0 0-3.81 2.09 4.73 4.73 0 0 0-1.19 1.38 11.09 11.09 0 0 0-1.47 7.31c.52 3.6 2.44 6.13 6.15 7 .41.1.82.19 1.24.25a19.29 19.29 0 0 0 7.68-.37 14.6 14.6 0 0 0 11.28-10.65 15.84 15.84 0 0 0 .71-4.43v-7.74a6.4 6.4 0 0 0-.01-.75Z",
                            style: {
                                fill: "url(#g)"
                            }
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M563.32 98.59c-.48 0-.81.06-1.14.06h-8.88a10.11 10.11 0 0 1-3.19-.47 8.83 8.83 0 0 1-6.35-7.2 16 16 0 0 1-.22-2.94V50.29a19.91 19.91 0 0 0-.3-3.93 10.59 10.59 0 0 0-4.79-7.16 15.13 15.13 0 0 0-17 .25 9.75 9.75 0 0 0-3.83 5.25 21.2 21.2 0 0 0-.65 3.45 21.87 21.87 0 0 0-.07 2.85v45.88a3.33 3.33 0 0 1-.16 1.63c-1.08.17-18.2.21-19.8 0a5.82 5.82 0 0 1-.16-.77v-44.1a50.73 50.73 0 0 1 1.32-12.15 27.52 27.52 0 0 1 2.9-7.26 18.87 18.87 0 0 1 6.37-6.65 44.56 44.56 0 0 1 16.88-6.39 41.08 41.08 0 0 1 25.65 4.4c.71.37 1.4.78 2.09 1.17a19.31 19.31 0 0 1 8 8.67 33.2 33.2 0 0 1 2.75 9.13 58.87 58.87 0 0 1 .69 9.83v42.53c-.06.51-.09 1.02-.11 1.67Z",
                            style: {
                                fill: "url(#h)"
                            }
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M698.82 98.56c-.47 0-.74.09-1 .09h-9.31a9.35 9.35 0 0 1-7-3 8.7 8.7 0 0 1-2.33-5 26.31 26.31 0 0 1-.18-2.85V50.34a19.75 19.75 0 0 0-.38-4.34 10.43 10.43 0 0 0-4.62-6.69 15.2 15.2 0 0 0-16.48-.31 10.69 10.69 0 0 0-4.91 7.4 21.5 21.5 0 0 0-.29 3.92v46.5a5.81 5.81 0 0 1-.07 1.58 1 1 0 0 1-.18.17.33.33 0 0 1-.13 0h-18.75c-.23 0-.46 0-.77-.05a6.38 6.38 0 0 1-.17-.8V53.78a51.66 51.66 0 0 1 1.23-12A28.45 28.45 0 0 1 636 35a19.33 19.33 0 0 1 7-7.55A44.48 44.48 0 0 1 661.14 21a40.63 40.63 0 0 1 20.55 2.94 44.21 44.21 0 0 1 6 3 19.07 19.07 0 0 1 7 7.21 29.18 29.18 0 0 1 3 8.43 54 54 0 0 1 1.08 11.2v43.38Z",
                            style: {
                                fill: "url(#i)"
                            }
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M768.65 45.45c-1.21.2-18.74.2-20 0l-.79-1.45a12.67 12.67 0 0 0-9.8-6.55 17.43 17.43 0 0 0-7.8.55 12.23 12.23 0 0 0-7.1 5.65 22.71 22.71 0 0 0-2.55 7 51.08 51.08 0 0 0-.69 14 35.12 35.12 0 0 0 1.24 7.2 18.3 18.3 0 0 0 3.59 6.79 12.66 12.66 0 0 0 7.37 4.36 19.67 19.67 0 0 0 9.34-.35 13.26 13.26 0 0 0 3.71-1.65 19.72 19.72 0 0 0 2.47-2.29c.37-.36.7-.76 1.05-1.14a7.73 7.73 0 0 1 5.79-2.47H769c.39.4.15.72.06 1-3.25 11.36-10.53 18.82-21.83 22.29a42.44 42.44 0 0 1-15.62 1.55A36.4 36.4 0 0 1 722 98a30.24 30.24 0 0 1-17-15 40.16 40.16 0 0 1-3.87-11.86 66.66 66.66 0 0 1-.78-15.71 46.88 46.88 0 0 1 3-14.55 31.83 31.83 0 0 1 8.92-12.82A29.82 29.82 0 0 1 726 21.5a45.52 45.52 0 0 1 13.18-.65 39.48 39.48 0 0 1 10.69 2.35 30.55 30.55 0 0 1 6.36 3.32 26.3 26.3 0 0 1 7.29 7.35 41.24 41.24 0 0 1 5 10.53c.07.22.13.45.18.68a2.19 2.19 0 0 1-.05.37Z",
                            style: {
                                fill: "url(#j)"
                            }
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M105.68 98.61H85.63a6.38 6.38 0 0 1-.17-.8V10.94a14.85 14.85 0 0 1 .16-2.67A10.17 10.17 0 0 1 95.08.05c3.33-.1 6.67 0 10 0a3.92 3.92 0 0 1 .61.09c0 .29.1.55.12.82s0 .75 0 1.13v94.59a6.53 6.53 0 0 1-.13 1.93Z",
                            style: {
                                fill: "url(#k)"
                            }
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M470.06 22.42c.36 0 .59-.06.83-.06h9.58a9.72 9.72 0 0 1 9.27 7.29 15.13 15.13 0 0 1 .3 2.23v64.79a5.8 5.8 0 0 1-.13 1.88c-1.64.19-3.27.06-4.9.09s-3.38 0-5.08 0H475c-1.65 0-3.27.09-5-.08 0-.33-.08-.59-.09-.86s0-.57 0-.85V24.18a5.72 5.72 0 0 1 .15-1.76Z",
                            style: {
                                fill: "url(#l)"
                            }
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M489.9 15.69a1.66 1.66 0 0 1-.39.11h-19a1.27 1.27 0 0 1-.36-.09l-.13-.13a.33.33 0 0 1 0-.13q0-7.09-.05-14.2v-1a4.56 4.56 0 0 1 .84-.18h10A9.63 9.63 0 0 1 490 8.68c.11 2.2.06 4.4.07 6.6a1.3 1.3 0 0 1-.17.41Z",
                            style: {
                                fill: "url(#m)"
                            }
                        })
                    ]
                })
            })
        ]
    }));
};
export default /*#__PURE__*/ React.memo(Logo, function(prev, next) {
    return prev.isDark === next.isDark;
});
